import React, {useEffect} from 'react';
import './App.less';
import {AppRouter} from "./ump-core/routers/AppRouter";
import {AUTH_TOKEN, REFRESH_TOKEN, USER_INFO} from "./ump-core/config";
import {AuthService} from "./ump-core/services/AuthService";

function App() {
    useEffect(() => {
        const access_token  = localStorage.getItem(AUTH_TOKEN);
        const refresh_token = localStorage.getItem(REFRESH_TOKEN);
        const user          = JSON.parse(localStorage.getItem(USER_INFO) as string);
        if (access_token && refresh_token && user) {
            AuthService.setLogin({
                access_token,
                refresh_token,
                user,
            });
            return;
        } else {
            localStorage.clear();
        }
    }, []);
  return (
    <>
        <AppRouter/>
    </>
  );
}

export default App;
